<template>
  <div>
    <a-table :columns="columns" :data-source="datalist" bordered
      :pagination="pagination" :scroll="{ x: 1200, y:500}" :loading="loading.table" size="small"
      key="tblMonitoring" :rowKey="(record, index) => {return index;}"
      :rowClassName="(record, index) => getStyleRow(record.keterangan_sistem!=null ? record.keterangan_sistem : '',record.status,record)">
      <template slot="title">
        <div class="ant-card-head" style="padding:0px!important;">
          <div class="ant-card-head-wrapper">
            <div class="ant-card-head-title" style="padding:0px!important;">
              <div slot="title" class="d-flex flex-row justify-between nowrap">
                <span>
                <a-icon type="pic-center" />
                &nbsp;&nbsp;Daftar Absensi Karyawan
                </span>
                <a-button  type="primary" style="margin-bottom:8px" @click="handleExport" v-if="isHrd">Export</a-button>
              </div>
            </div>
          </div>
        </div>
        <div class="act-grid" style="margin-top:12px">
          <a-row :gutter="{ xs: 0, lg: 8 }">
              <a-col :xs="24" :lg="24">
                <a-row :gutter="16">
                  <a-col :xs="24" :lg="16">
                    <a-form-item >
                    <a-input-search v-decorator="[
                      'search']" ref="search" @change="cari" placeholder="Pencarian ... " class="m-right" :loading="freeTexSearch.loading">
                      </a-input-search>
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :lg="4">
                    <a-date-picker :format="getDefaultDateFormat" v-model="f_date" @change="f_dateChange" 
                      :class="isMobile ? 'margin-top w-full' : 'w-full m-right'"/>
                  </a-col>
                  <a-col :xs="24" :lg="4">
                    <a-select v-model="f_jns" show-search :class="isMobile ? 'm-right margin-top w-full' : 'w-full m-right'"
                      placeholder="Pilih Kategori" :filterOption="optionFilter" @change="kategoriChange">
                      <a-select-option key="1" value="1">Telah Sidik Jari</a-select-option>
                      <a-select-option key="2" value="2">Belum Sidik Jari</a-select-option>
                    </a-select>
                  </a-col>
                  <!-- <a-col :xs="24" :lg="3" v-if="!isMobile">
                    <a-button type="primary" :class="isMobile ? 'margin-top w-full' : 'w-full'" @click="handleExport">Export</a-button>
                  </a-col> -->
                </a-row>
              </a-col>
            </a-row>
          <!-- <a-row :gutter="{ xs: 0, lg: 8 }" >
          <a-col :xs="24" :lg="24">
            <div :class="isMobile ? 'content-filter' : 'd-flex justify-start content-filter'">
              
            </div>
          </a-col>
        </a-row> -->
        </div>
      </template>
      <span slot="customTitle">Nama Karyawan</span>
      <template slot="name" slot-scope="value, item">
        <a-button type="link" shape="circle" icon="history" size="small" class="raise" @click="handleshowModal(item)"/>
        <span class="margin-left">({{ item.tlc }}) {{item.nama}}</span>
      </template>
      <span slot="no" slot-scope="value, item, index">
        {{ (pagination.page - 1) * pagination.pageSize + (index + 1) }}
      </span>
      <span slot="check_in" slot-scope="value">
        {{ value.check_in }}
        <span v-if="value.foto_check_in" style="padding-left:1px;padding-right:5px;">&nbsp;&nbsp;&nbsp;<a-icon @click="viewPhoto(value.foto_check_in, value.note_check_in)" type="camera" /></span>
        <span v-if="value.latitude_check_in" style="padding-right:5px;">&nbsp;&nbsp;&nbsp;<a-icon @click="viewGoogleMaps(value.latitude_check_in,value.longitude_check_in)" type="environment" /></span>
      </span>
      <span slot="check_out" slot-scope="value">
        {{ value.check_out }}
        <span v-if="value.foto_check_out" style="padding-left:1px;padding-right:5px;">&nbsp;&nbsp;&nbsp;<a-icon @click="viewPhoto(value.foto_check_out, value.note_check_out)" type="camera" /></span>
        <span v-if="value.latitude_check_out" style="padding-right:5px;">&nbsp;&nbsp;&nbsp;<a-icon @click="viewGoogleMaps(value.latitude_check_out,value.longitude_check_out)" type="environment" /></span>
      </span>
      <span slot="tags" slot-scope="tags">
        <a-tag
          v-for="tag in tags"
          :key="tag"
          :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'"
        >
          {{ tag.toUpperCase() }}
        </a-tag>
      </span>
      <span slot="keterangan" slot-scope="text, record">
        <table>
          <tr>
            <td style="width:40px">
              <a-button type="link" class="m-right" size="small"  @click="handleModalKet(record)"><a-icon type="edit"/></a-button> 
            </td>
            <td>
              <span v-if="record.keterangan_sistem">{{record.keterangan_sistem}}<br/></span>
              <b v-if="record.jenis_keterangan">{{record.jenis_keterangan}}</b>
              <span v-if="record.keterangan_ijin">
              <br/>Ket : {{record.keterangan_ijin}}
              <a-button v-if="record.path_file" type="link" shape="circle" icon="file" size="small" class="raise" @click="handleshowFile(record.path_file)"/>
              <br/>
              </span>
              <span v-if="record.status_hrd">
                HRD: {{record.keterangan_hrd}}<br/>
                <a-tag :color="record.status_hrd=='Approved_without_deduction' ? 'green' : 'red'">
                  {{record.status_hrd== 'Approved_without_deduction'  ?  'Approved Tanpa Potongan' : 'Approved Dengan Potongan' }}
                </a-tag>
              </span>
              <a-button v-if="record.url"
                type="link" class="m-left" size="small"  @click="handleViewfile(record.url)"><a-icon type="file"/></a-button>
            </td>
          </tr>
        </table>
      </span>
    </a-table>
    <!-- div berikut untuk kebutuhan export data -->
    <div class="contentTable"> 
      <a-table :columns="columnsShadow" :data-source="datalist_origin" bordered :pagination="false"
      :scroll="{ x: 1200}" :loading="loading.table" size="small"
      key="tblMonitoring" :rowKey="(record, index) => {return index;}"
      :rowClassName="(record, index) => getStyleRow(record.keterangan_sistem!=null ? record.keterangan_sistem : '',record.status,record)">
      <span slot="customTitle">Nama Karyawan</span>
      <template slot="name" slot-scope="value, item">
        <a-button type="link" shape="circle" icon="history" size="small"/>
        ({{ item.tlc }}) {{item.nama}}
      </template>
      <span slot="no" slot-scope="value, item, index">
        {{ (pagination.page - 1) * pagination.pageSize + (index + 1) }}
      </span>
      <span slot="check_in" slot-scope="value">
          {{ value.check_in }}
        </span>
        <span slot="check_out" slot-scope="value">
          {{ value.check_out }}
        </span>
      <span slot="tags" slot-scope="tags">
        <a-tag
          v-for="tag in tags"
          :key="tag"
          :color="tag === 'loser' ? 'volcano' : tag.length > 5 ? 'geekblue' : 'green'"
        >
          {{ tag.toUpperCase() }}
        </a-tag>
      </span>
      <span slot="keterangan" slot-scope="text, record">
        {{record.jenis_keterangan}} {{record.keterangan_sistem}} {{record.keterangan_ijin}}
        <span v-if="record.keterangan_ijin"><br/>{{record.keterangan_ijin}}</span>
      </span>
    </a-table>
    </div>


    <a-modal
      v-model="modal.visible"
      centered
      :maskClosable="false"
      :footer="false"
      @cancel="handleCloseModalHist"
    >
      <template slot="title">
        <h3>Detail Log. Absensi</h3>
        {{modal.title}}
      </template>
      <a-table key="tbllog" :columns="columnsDtlLog" :data-source="modal.datalist" :loading="modal.loading"
        :rowKey="(record, index) => {return index;}" size="small" bordered>
        <span slot="dtlno" slot-scope="value, item, index">
          {{ (index + 1) }}
        </span>
        <span slot="sumber" slot-scope="value, item">
          {{ item.machine }} 
          <div v-if="item.divice_nm">
            {{ item.divice_nm }}
          </div>
          <div v-if="item.latitude">
            <br/>
            <b>lat :</b> {{ item.latitude }}
          </div>
          <div v-if="item.longitude">
            <b>Long :</b> {{ item.longitude }}
          </div>
          <div v-if="item.latitude && item.longitude">
            <b>Photo</b> ( <a v-if="item.file_url" style="padding-left:1px;padding-right:5px;" class="bob-on-hover">&nbsp;&nbsp;&nbsp;<a-icon @click="handleViewfile(value.file_url)" type="camera" /></a>)
            ,&nbsp;<b>Maps</b> ( <a v-if="item.latitude" style="padding-right:5px;" class="bob-on-hover">&nbsp;&nbsp;&nbsp;<a-icon @click="viewGoogleMaps(item.latitude, item.longitude)" type="environment" /></a>)
          </div>
          <div v-if="item.note">
            <b>Keterangan :</b> {{ item.note }}
          </div>
        </span>
        <span slot="log" slot-scope="value, item">
          {{ item.log_dtl }}
        </span>
        <template slot="footer" >
          <b>Total Jam Kerja : {{modal.total_jam}}</b>
        </template>
      </a-table>
    </a-modal>

    <a-modal
      v-model="modal2.visible"
      centered
      :maskClosable="false"
      @cancel="handleCancelModalKet"
      :confirmLoading	="modal2.loading"
      @ok="handlePerijinan"
    >
      <template slot="title">
        <h3>Buat Keterangan</h3>
      </template>
      <a-spin :spinning="modal2.loadingPage">
        <a-form :form="formKet">
          <a-form-item  label="Jenis">
            <a-select
              placeholder="Pilih Jenis Keterangan"
              v-decorator="[
                      'jenis',
                      {
                        rules: [{ required: true }],initialValue:modal2.form.jenis,
                      },
                    ]"
              class="w-full"
              @change="HandleChangeJenis"
            >
              <a-select-option value="Ijin Terlambat">Ijin Terlambat</a-select-option>
              <a-select-option value="Ijin Pulang Awal">Ijin Pulang Awal</a-select-option>
              <a-select-option value="Ijin Tidak Masuk (Sakit)">Ijin Tidak Masuk (Sakit)</a-select-option>
              <a-select-option value="Ijin Tidak Masuk (Lain-Lain)">Ijin Tidak Masuk (Lain-Lain)</a-select-option>
              <a-select-option value="Perjalanan Dinas">Perjalanan Dinas</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item  label="Keterangan Pegawai">
            <a-textarea
                  placeholder="Keterangan ijin ... "
                  v-decorator="[
                      'description',
                      {
                        rules: [{ required: false }],initialValue:modal2.form.jenis,
                      },
                    ]"
                  class="w-full"
                />
          </a-form-item>
          <a-card class="bg-action">
            <a-form-item  label="Keterangan HRD">
              <a-textarea
                    placeholder="Keterangan HRD ... "
                    v-decorator="[
                        'hrd_ket',
                        {
                          rules: [{ required: false }],initialValue:modal2.form.jenis,
                        },
                      ]"
                    class="w-full"
                  />
            </a-form-item>
            <a-form-item v-if="modal2.EnableUploadDoc"
              label="Upload Document">
              <a-upload
                  class="floating-button"
                  :showUploadList="true"
                  :fileList="push"
                  :beforeUpload="beforeUpload"
                  :remove="handleRemoveFile"
                  v-decorator="[
                    'upload',
                    { rules: [{ required: true }] },
                    { valuePropName: 'push' },
                  ]"
                >
                  <a-button>
                    <a-icon type="upload" />&nbsp;Select File
                  </a-button>
                </a-upload>
            </a-form-item>
            <a-form-item
              label="Aksi">
              <a-radio-group 
                v-decorator="[
                  'hrd_sts',
                  {
                    rules: [{ required: true }],initialValue:modal2.form.hrd_sts,
                  },
                ]" button-style="solid">
                <a-radio-button key="1" value="Approved_without_deduction">Approved Tanpa Potongan</a-radio-button>
                <a-radio-button key="2" value="Approved_with_deduction">Approved Dengan Potongan</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-card>
        </a-form>
      </a-spin>
    </a-modal>

    <a-modal
      v-model="modalExport.visible"
      v-if="modalExport.visible"
      centered
      :width="350"
      :maskClosable="false"
      :footer="false"
      @cancel="handleCloseExport"
    >
      <template slot="title">
        <h3>Export</h3>
      </template>
      <a-spin :spinning="modalExport.loadingPage">
        <a-form :form="formExport">
          <a-form-item  label="Tipe Export">
            <a-select
              placeholder="Pilih Tipe Export"
              v-decorator="[
                'tipe',
                {
                  rules: [{ required: true }], initialValue: 'harian',
                },
              ]"
              class="w-full"
              @change="HandleChangeTipe"
            >
              <a-select-option value="harian">Harian</a-select-option>
              <a-select-option value="periode">Periode</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item  label="Tanggal" v-if="modalExport.tipe=='harian'">
            <a-date-picker :format="getDefaultDateFormat" 
              v-decorator="[
                'tgl',
                {
                  rules: [{ required: true }], initialValue: moment(),
                },
              ]"
              @change="HandleChangetgl"
              :class="isMobile ? 'margin-top w-full' : 'w-full m-right'"/>
          </a-form-item>
          <a-form-item  label="Tanggal" v-if="modalExport.tipe == 'periode'">
            <a-range-picker
              v-decorator="[
                'periode',
                {
                  rules: [{ required: true }], initialValue:[moment(),moment()]
                }, 
              ]"
              class="w-full"
              :format="getDefaultDateFormat"
            />
          </a-form-item>
          <a-button  type="primary" class="margin-top" 
          :disabled="modalExport.disabled"
          :loading="modalExport.loading" @click="handleExportModal">Export</a-button>
        </a-form>
      </a-spin>
    </a-modal>

    <a-modal
      v-model="modal3.visible"
      centered
      :width="isMobile ? '100%' : '40%'"
      :maskClosable="false"
      @cancel="handleCancelModalKet"
      @ok="handlePerijinan"
      :footer="false"
    >
      <template slot="title">
        <h3>View Photo</h3>
      </template>
      <img :src="modal3.url" style="width: 100%;">
      <b>Keterangan</b> : {{ modal3.keterangan }}
  </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
//import Grid from "@/components/AbsensiGrid.vue";
import moment from "moment";
import _ from "lodash";

const plainOptions = ["Gaji", "Value"];
const defaultCheckedList = [];

export default {
  name: "MonitoringAlokasiPekerjaan",
  props: ["spesialFor"],
  components: {
    //"H-AbsensiGrid": Grid,
  },
  data() {
    return {
      datalist:[],
      datalist_origin:[],
      //search: undefined,
      f_date: null,
      f_jns: "1",
      pagination: {
        page: 1,
        onChange: (page) => {
          this.pagination.page = page;
        },
        pageSize: 50,
        size: "default"
      },
      loading:{
        table: false,
      },
      indeterminate: true,
      checkAll: false,
      plainOptions,
      checkedList: defaultCheckedList,
      referencedata: this.columns1,
      modal: {
        visible : false,
        title: 'Mocammad Zainal (MZA) - 01-09-2022',
        datalist: [],
        loading: false,
        total_jam: "",
      },
      modal2: {
        id_perijinan: null,
        visible : false,
        EnableUploadDoc: false,
        loading: false,
        loadingPage:false,
        form:{
          tlc:"",
          jenis:"",
          keterangan:"",
        }
      },
      modal3: {
        visible: false,
        url: null,
      },
      push: [],
      modalExport: {
        visible: false,
        loadingPage: false,
        tipe: 'harian',
        loading: false,
        disabled: false,
      },
      freeTexSearch: {
        timeoutSearchKetik: null,
        laoding: false
      }
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate"]),
    columns(){
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const columns = [
        {
          title: 'No',
          scopedSlots: { customRender: "no" },
          width:45,
          key: 'no',
          align:"right",
          fixed: this.isMobile ? false : "left",
        },
        {
          key: 'name',
          width: 300,
          slots: { title: 'customTitle' },
          scopedSlots: { customRender: "name" },
          fixed: this.isMobile ? false : "left",
          sorter: (a, b) => b.tlc.localeCompare(a.tlc),
        },
        {
          title: 'Check  In',
          width:120,
          key: 'check_in',
          align:"center",
          scopedSlots: { customRender: "check_in" },
          sorter: (a, b) => (b.check_in ? b.check_in : " ").localeCompare(a.check_in ? a.check_in : ""),
        },
        {
          title: 'Check  Out',
          width:120,
          key: 'check_out',
          align:"center",
          scopedSlots: { customRender: "check_out" },
          sorter: (a, b) => (b.check_out ? b.check_out : " ").localeCompare(a.check_out ? a.check_out : ""),
        },
        {
          title: 'Total Jam',
          width:200,
          dataIndex: 'total_jam',
          key: 'total_jam',
        },
        {
          title: 'Status',
          width:200,
          dataIndex: 'status',
          key: 'status',
          sorter: (a, b) => (b.status ? b.status : " ").localeCompare(a.status ? a.status : ""),
        },
        {
          title: 'Keterangan',
          width:450,
          key: 'keterangan',
          scopedSlots: { customRender: 'keterangan' },
        },
      ];
      return columns;
    },
    columnsShadow() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const columns = [
        {
          title: 'No',
          scopedSlots: { customRender: "no" },
          width: 45,
          key: 'no',
          align: "right",
        },
        {
          key: 'name',
          width: 300,
          slots: { title: 'customTitle' },
          scopedSlots: { customRender: "name" },
          sorter: (a, b) => b.tlc.localeCompare(a.tlc),
        },
        {
          title: 'Check  In',
          width: 120,
          key: 'check_in',
          align: "center",
          scopedSlots: { customRender: "check_in" },
          sorter: (a, b) => (b.check_in ? b.check_in : " ").localeCompare(a.check_in ? a.check_in : ""),
        },
        {
          title: 'Check  Out',
          width: 120,
          key: 'check_out',
          align: "center",
          scopedSlots: { customRender: "check_out" },
          sorter: (a, b) => (b.check_out ? b.check_out : " ").localeCompare(a.check_out ? a.check_out : ""),
        },
        {
          title: 'Total Jam',
          width: 200,
          dataIndex: 'total_jam',
          key: 'total_jam',
        },
        {
          title: 'Status',
          width: 200,
          dataIndex: 'status',
          key: 'status',
          sorter: (a, b) => (b.status ? b.status : " ").localeCompare(a.status ? a.status : ""),
        },
        {
          title: 'Keterangan',
          width: 450,
          key: 'keterangan',
          scopedSlots: { customRender: 'keterangan' },
        },
      ];
      return columns;
    },
    columnsDtlLog(){
      const DtlLog = [
        {
          title: 'No',
          scopedSlots: { customRender: "dtlno" },
          key: 'no',
          align:"right"
        },
        {
          title: 'Sumber',
          scopedSlots: { customRender: "sumber" },
          key: 'sumber',
        },
        {
          title: 'Cara',
          dataIndex: 'cara',
          key: 'cara',
        },
        {
          title: 'Log',
          scopedSlots: { customRender: "log" },
          key: 'log',
          align: "center"
        },
      ];
      return DtlLog
    },
    isHrd() {
      let result = false
      if (this.$route.meta && this.$route.meta.isHRD) {
        result = true
      }
      return result
    }
  },
  beforeCreate(){
    this.formKet = this.$form.createForm(this);
    this.formExport = this.$form.createForm(this);
  },
  created() {
    //this.fetching();
  },
  methods: {
    moment,
    cari(val) {
      //console.log(val.target.value)
      // console.log(val.target.value,this.$refs.search.$el.__vue__.value)
      clearTimeout(this.freeTexSearch.timeoutSearchKetik);

      const that = this
      this.freeTexSearch.timeoutSearchKetik = setTimeout(function () {
        that.freeTexSearch.loading = true;
        that.searching(val.target.value);
        that.freeTexSearch.loading = false;
      },300)
    },
    async fetching() {
      this.loading.table = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "absensi/monitoring",
        params: {
          "X-API-KEY": this.getAuth.apikey,
          tlc: this.getAuth.username,
          start_dt: moment(this.f_date).format(this.getStandartFormatDate),
          end_dt:moment(this.f_date).format(this.getStandartFormatDate),
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        }
      })
        .then(response => {
          let tempdata = response.data.data;
          for (let i = 0; i < tempdata.length; i++) {
            tempdata[i].q_search = (tempdata[i].tlc ? tempdata[i].tlc : "").toLowerCase() + " " +
            (tempdata[i].nama ? tempdata[i].nama : "").toLowerCase() + " " +
            (tempdata[i].keterangan_ijin ? tempdata[i].keterangan_ijin : "").toLowerCase() + " " +
            (tempdata[i].keterangan_sistem ? tempdata[i].keterangan_sistem : "").toLowerCase() + " " +
            (tempdata[i].keterangan_hrd ? tempdata[i].keterangan_hrd : "").toLowerCase()
          }
          this.datalist_origin = tempdata;
          
          //default daftar yang telah absensi
          this.f_jns = "1";
          this.searching(null);

          this.loading.table = false;
          this.modalExport.disabled = false;
        })
        .catch(err => {
          this.loading.table = false;
          this.modalExport.disabled = false;
          console.log(err.response);
        });
    },
    optionFilter(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    async kategoriChange(){
      this.loading.table = true;
      await this.searching(null);
      this.loading.table = false;
    },
    f_dateChange(){
      
      this.fetching();
    },
    getStyleRow(val,status,isi){
      let result='';
      if (val.length==1){
        if(status=='Sudah Check Out'){
          result='row_hijau';
        }
      } else if (val.length>1 && val.substring(0, 4)=='Ijin'){
        result = 'row_kuning'
      } else if (val.length>1 && val.substring(0, 9)=='Terlambat'){
        result = 'row_merah'
      } else if (val.length>1 && val.substring(0, 17)=='Warning Terlambat'){
        result = 'row_krem'
      } else {
        result = ''
      }

      if (isi.total_jam_raw) {
        if (isi.total_jam_raw.substring(0, 2) == "08") {
          result = ''
        } else {
          result = 'row_merah'
        }
      }

      return result
    },
    searching(val) {
      let src = val ? val : this.$refs.search.$el.__vue__.value;
      if(this.f_jns=="1"){
        if (src) {
          let tsearch = src.toLowerCase()
          this.datalist = _.filter(
            this.datalist_origin,
            (nav) => nav.check_in != null && nav.q_search.indexOf(tsearch) >= 0
          );
        } else {
          this.datalist = _.filter(this.datalist_origin,
            (nav) => (nav.check_in != null));
        }
      } else {
        if (src) {
          let tsearch = src.toLowerCase()
          this.datalist = _.filter(
            this.datalist_origin,
            (nav) => nav.check_in == null && nav.q_search.indexOf(tsearch) >= 0
          );
        } else {
          this.datalist = _.filter(this.datalist_origin,
            (nav) => (nav.check_in == null));
        }
      }
    },
    handleExport() {
      this.modalExport.tipe = 'harian';
      this.modalExport.visible = true;
      // this.$nextTick(() => {
      //   this.formExport.setFieldsValue({
      //     tgl: this.f_date
      //   });
      // });
    },
    onChange(checkedList) {
      var _that = this;
      if (checkedList.length > 0) {
        //For individually selected functions
        this.indeterminate =
          !!checkedList.length && checkedList.length < plainOptions.length;
        this.checkAll = checkedList.length === plainOptions.length;
        //Just control the data rendering of checkedList
        //Modify the table data

        // console.log(this.columns)
        this.referencedata = JSON.parse(JSON.stringify(this.columns1)); //This treatment prevents the address from being passed
        let deletearray = JSON.parse(JSON.stringify(this.columns1));

        let targetValueList = checkedList.indexOf("Value");
        let targetGaji = checkedList.indexOf("Gaji");

        let valueList = [];

        let listcolumn = [];
        if (targetValueList >= 0) {
          valueList.forEach((item) => {
            listcolumn.push(item);
          });
        }

        if (targetGaji >= 0) {
          listcolumn.push("Gaji");
        }

        checkedList.forEach((item) => {
          if (item == "Gaji") {
            for (let i = 0; i < deletearray.length; i++) {
              if (item == deletearray[i].title || item == deletearray[i]) {
                deletearray.splice(i, 1);
                _that.referencedata = deletearray;
              }
            }
          }
          if (item == "Value") {
            for (let i = 0; i < deletearray.length; i++) {
              if (deletearray[i].title == "Kode Proyek") {
                const child = deletearray[i].children;
                for (let a = 0; a < child.length; a++) {
                    child[a].children.pop();
                    _that.referencedata = deletearray;
                }
              }
            }
          }
        });
      } else {
        _that.referencedata = this.columns1;
      }
    },
    fireDownload(table, name) {
      let uri = "data:application/vnd.ms-excel;base64,",
        template =
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/><style>table, td {border:thin solid black}table {border-collapse:collapse}</style></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
          return s.replace(/{(\w+)}/g, function (m, p) {
            return c[p];
          });
        };
      if (!table.nodeType) table = document.getElementsByClassName("contentTable");
      
      let sourceHTML = table[0].innerHTML;
      
      //replace to change color background
      sourceHTML = sourceHTML.replaceAll('class="ant-table-row ant-table-row-level-0 row_hijau"','style="background-color:#d3f897"');
      sourceHTML = sourceHTML.replaceAll('class="ant-table-row ant-table-row-level-0 row_kuning"','style="background-color:#ffe08f"');
      sourceHTML = sourceHTML.replaceAll('class="ant-table-row ant-table-row-level-0 row_merah"','style="background-color:#ea8c8c"');
      sourceHTML = sourceHTML.replaceAll('class="ant-table-row ant-table-row-level-0 row_krem"','style="background-color:#fcffb2"');

      let ctx = { worksheet: name || "Worksheet", table: sourceHTML };
      let a = document.createElement("a");
      a.href = uri + base64(format(template, ctx));
      a.download = "Absensi_"+moment().format('YYYY-MM-DD')+".xls";
      a.click();
    },
    handleshowModal(item){
      //console.log(item)
      this.modal.title = item.nama + " (" + item.tlc +") - "+moment(this.f_date).format('DD-MM-YYYY');
      this.modal.visible = true;
      this.modal.loading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "absensi/log_absen",
        params: {
          "X-API-KEY": this.getAuth.apikey,
          tlc: item.tlc,
          tgl: item.tgl,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        }
      })
        .then(response => {
          this.modal.datalist = response.data.dtl;
          this.modal.total_jam = response.data.total_jam;
          this.modal.loading = false;
        })
        .catch(err => {
          this.modal.loading = false;
          console.log(err.response);
        });
    },
    handleCancel(){
      this.modal.visible = false;
    },
    handleModalKet(val){
      this.modal2.visible = true;
      this.modal2.loadingPage = true;
      this.formKet.resetFields();
      this.modal2.EnableUploadDoc=false;
      this.push=[];
      this.modal2.tlc=val.tlc;
      this.modal2.tgl=val.tgl;

      if(val.perijinan_id){
        axios({
          method: "get",
          url: this.$serviceUrl + "absensi/perijinan",
          params: {
            "X-API-KEY": this.getAuth.apikey,
            perijinan_id: val.perijinan_id,
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          }
        })
        .then(response => {
          this.modal2.id_perijinan = response.data.data[0].perijinan_id;

          this.formKet.setFieldsValue({
            jenis: response.data.data[0].jenis,
            description: response.data.data[0].keterangan,
            hrd_ket: response.data.data[0].hrd_ket,
            hrd_sts: response.data.data[0].hrd_sts,
            });
          this.modal2.loadingPage = false;
        })
        .catch(err => {
          this.modal2.visible = false;
          this.modal2.loadingPage = false;
          console.log(err.response);
        });
      }else{
        this.modal2.id_perijinan = null;
        this.modal2.loadingPage = false;
      }
    },
    handleCancelModalKet(){
      this.modal2.visible = false;

    },
    beforeUpload(file) {
      this.push = [];
      this.push.push(file);
      return false;
    },
    HandleChangeJenis(val){
      if(val=='Ijin Tidak Masuk (Sakit)'){
        this.modal2.EnableUploadDoc = true;
      }else{
        this.modal2.EnableUploadDoc = false;
        this.push = [];
      }
    },
    handleRemoveFile(){
      this.push = [];
    },
    handlePerijinan(item){
      this.formKet.validateFields((err, values) => {
          if (err) {
            this.displayMessage("form-warning");
            return;
          }

          let data = new FormData();
        data.append("X-API-KEY", this.getAuth.apikey);
          data.append("tlc", this.modal2.tlc);
          data.append("tgl", this.modal2.tgl);
          data.append("jenis", values.jenis);
          data.append("keterangan", values.description ? values.description : "");
          data.append("hrd_sts", values.hrd_sts ? values.hrd_sts : "");
          data.append("hrd_ket", values.hrd_ket ? values.hrd_ket : "");

          if (values.jenis=='Ijin Tidak Masuk (Sakit)') {
            data.append("file_upload", this.push[0]);
          }
          
          if(this.modal2.id_perijinan)
            data.append("perijinan_id", this.modal2.id_perijinan);

          this.modal2.loading = true;
          axios({
          method: "post",
          url: this.$serviceUrl + (this.modal2.id_perijinan ? "absensi/perijinan_edit" : "absensi/perijinan"),
          data: data,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          }
        })
          .then(response => {
            // this.modal.datalist = response.data.dtl;
            // this.modal.total_jam = response.data.total_jam;
            // this.modal.loading = false;
            console.log(response.data)
            _.set(_.find(this.datalist, {tlc: this.modal2.tlc,tgl:this.modal2.tgl}), 'keterangan_ijin', response.data.keterangan);
            _.set(_.find(this.datalist, {tlc: this.modal2.tlc,tgl:this.modal2.tgl}), 'jenis_keterangan', response.data.jenis);
            _.set(_.find(this.datalist, {tlc: this.modal2.tlc,tgl:this.modal2.tgl}), 'keterangan_hrd', response.data.keterangan_hrd);
            _.set(_.find(this.datalist, {tlc: this.modal2.tlc,tgl:this.modal2.tgl}), 'url', response.data.url);
            _.set(_.find(this.datalist, {tlc: this.modal2.tlc,tgl:this.modal2.tgl}), 'status', response.data.jenis);
            _.set(_.find(this.datalist, {tlc: this.modal2.tlc,tgl:this.modal2.tgl}), 'status_hrd', response.data.sts_hrd);
            _.set(_.find(this.datalist, {tlc: this.modal2.tlc,tgl:this.modal2.tgl}), 'perijinan_id', response.data.perijinan_id);

            this.formKet.resetFields();
            this.modal2.EnableUploadDoc=false;
            this.push=[];

            this.modal2.visible = false;
            this.modal2.loading = false;
          })
          .catch(err => {
            err = Object.assign({}, err.response)
            if (err.data.message) {
              this.displayMessageValue("error-basic", err.data.message);
            } else {
              this.displayMessageValue("error-other", err);
            }
            this.modal2.loading = false;
            console.log(err.response);
          });
      });
    },
    handleViewfile(url){
      window.open(this.$serviceUrl+url, "_blank");
    },
    handleCloseModalHist(){
      this.modal.datalist = [];
    },
    viewPhoto(url, note){
      this.modal3.visible = true;
      this.modal3.url = this.$serviceUrl + url;
      this.modal3.keterangan = note;
      //window.open(this.$serviceUrl+url, "_blank");
    },
    viewGoogleMaps(lat,long){
      window.open("https://www.google.com/maps/search/"+lat+"++"+long, "_blank");
    },
    HandleChangeTipe(val) {
      this.modalExport.tipe = val;
      if (val == 'harian') {
        this.$nextTick(() => {
          this.formExport.setFieldsValue({
            tgl: this.f_date
          });
        });
      } else {
        let st = moment();
        let en = moment();
        if (parseInt(moment().format('DD')) > 27) {
          st = moment().set('date', 28);
          en = moment().subtract(-1, 'months').set('date', 27);
        } else {
          st = moment().subtract(1, 'months').set('date', 28);
          en = moment().set('date', 27);
        }
        this.$nextTick(() => {
          this.formExport.setFieldsValue({
            periode: [st,en]
          });
        });
      }
    },
    handleCloseExport() {
      this.modalExport.visible = false;
    },
    handleExportModal(table, name) {
      this.formExport.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (values.tipe == "harian") {
          this.modalExport.loading = true;
          setTimeout(() => {
            this.fireDownload(table, name);
            this.modalExport.loading = false;
          }, 3000);
        } else {
          this.$store.dispatch("getExportData", {
            auth: this.getAuth,
            param: {
              start_date: moment(values.periode[0]).format(this.getStandartFormatDate),
              end_date: moment(values.periode[1]).format(this.getStandartFormatDate),
              id: this.getAuth.username + "_Rekap_Absensi_"
                + moment(values.periode[0]).format(this.getStandartFormatDate) + "_" 
                + moment(values.periode[1]).format(this.getStandartFormatDate)
            }
          });
          setTimeout(function () { 
            Event.$emit("exportlistdata", { tipe: "new_loop" });
           }, 2000);
          
          this.modalExport.visible = false;
          this.displayMessageValue('info-basic', "Request data is being processed, check it on status bar!");
        }
      });
    },
    HandleChangetgl(val) {
      this.modalExport.disabled = true;
      this.f_date = val;
      this.fetching();
    },
    handleshowFile(path) {
      window.open(this.$serviceUrl + path, "_blank");
    }
  },
  mounted() {
    this.f_date = moment();
    this.fetching();
  },
  activated() {
  },
  watch: {
  },
};
</script>

<style lang="less">
.col_hidden {
  display: none;
}

.act-grid {
  padding-top:0px;
}

.content-filter{
  margin-top:12px;
  padding: 10px;
  background-color: fade(@primary-color, 55%);
  border-radius: 3px;
}
.row_merah{
  background-color: fade(#d00000,45%)!important;

}
.row_krem{
  background-color: #FCFFB2!important;
}
.row_kuning{
  background-color: fade(#ffba08,45%)!important;
}
.row_hijau{
  background-color: fade(#9ef01a,45%)!important;
}

.ant-table-thead{
  background-color: @primary-color!important;
  th {
    text-align: center!important;
    color: rgb(255 255 255)!important;
    font-weight: bold!important;
  }
}
.contentTable{
  display:none
}

.ant-table-tbody > tr.row_merah > td.ant-table-column-sort {
    background-color: #ea8c8c;
}
.ant-table-tbody > tr.row_krem > td.ant-table-column-sort {
    background-color: #fcffb2;
}
.ant-table-tbody > tr.row_kuning > td.ant-table-column-sort {
    background-color: #ffe08f;
}
.ant-table-tbody > tr.row_hijau > td.ant-table-column-sort {
    background-color: #d3f897;
}

.bg-action{
  background-color: fade(@primary-color,30%)!important;
}
</style>
